/**
 * Amplitude experiment key the native Android app uses to gate its own Reality
 * Check ownership. When enabled for the device, native owns and displays RC.
 */
const NATIVE_RC_EXPERIMENT_KEY = 'native-reality-check-casino-android';

/**
 * True when the Android native app owns Reality Check. The web shell must not
 * start its own web RC in that case, to avoid showing it twice.
 */
export const isNativeRealityCheckEnabled = (): boolean => {
  try {
    return (
      window?.AndroidWrapper?.isExperimentEnabled?.(
        NATIVE_RC_EXPERIMENT_KEY,
      ) === true
    );
  } catch {
    return false;
  }
};
